import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/shared/layout/Header";
import { Footer } from "@/shared/layout/Footer";
import { routes } from "@/app/navigation/routes";
import styles from "./NonAuthenticatedLayout.module.css";

/**
 * Layout for non-authenticated routes
 * Includes header and footer, but no sidebar
 */
export const NonAuthenticatedLayout = () => {
  const location = useLocation();
  const isLandingPage = location.pathname === routes.home || location.pathname === routes.landing;

  return (
    <div className={styles.nonAuthenticatedLayout}>
      <Header />
      <main className={`${styles.mainContent} ${isLandingPage ? styles.landingPage : ""}`}>
        <Outlet />
      </main>
      {!isLandingPage && <Footer />}
    </div>
  );
};
